import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { ITransferenceOrder } from "domain/Inventory/Models/ITransferenceOrder";
import { SBTranslate } from "i18n";
import { SBBox, SBIcon } from "modules/Commons";

export const useTransferenceOrderHeaders = () => {
	const { add, build, integerFormatter, dateFormatter } =
		useTableColumnBuilder<ITransferenceOrder>();

	add({
		id: () => "inventory",
		name: " ",
		hideToggle: true,
		headers: [
			{
				id: (c) => (
					<SBBox style={{ cursor: "pointer" }}>
						<SBIcon icon="inventory" hoverFillColor="primary" />
					</SBBox>
				),
				csvName: SBTranslate("inventory"),
				align: "center",
				csvHide: true,
				width: 1,
				key: "inventory",
				name: "",
				fixed: true,
			},
		],
	});

	add({
		id: () => "order",
		name: "order",
		headers: [
			{
				id: (c) => c.guid ?? "",
				key: "guid",
				name: SBTranslate("code"),
				csvName: SBTranslate("transferenceOrderCSVNames.guid"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.documentNumber ?? "---",
				key: "documentNumber",
				name: SBTranslate("documentNumber"),
				csvName: SBTranslate("transferenceOrderCSVNames.documentNumber"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "product",
		name: "product",
		headers: [
			{
				id: (c) => c.productClientID ?? "",
				key: "productClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("transferenceOrderCSVNames.productClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.productName ?? "",
				key: "productName",
				name: SBTranslate("product"),
				csvName: SBTranslate("transferenceOrderCSVNames.productName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "store",
		name: "store",
		headers: [
			{
				id: (c) => c.destinationStoreClientID ?? "",
				key: "storeClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("transferenceOrderCSVNames.storeClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.destinationStoreName ?? "",
				key: "storeName",
				name: SBTranslate("store"),
				csvName: SBTranslate("transferenceOrderCSVNames.storeName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "sourceStore",
		name: "sourceStore",
		headers: [
			{
				id: (c) => c.sourceStoreClientID ?? "",
				key: "sourceStoreClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("transferenceOrderCSVNames.sourceStoreClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.sourceStoreName ?? "",
				key: "sourceStoreName",
				name: SBTranslate("sourceStore"),
				csvName: SBTranslate("transferenceOrderCSVNames.sourceStoreName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "dates",
		name: "dates",
		headers: [
			{
				id: (c) => c.created ?? "",
				key: "created",
				name: SBTranslate("created"),
				csvName: SBTranslate("transferenceOrderCSVNames.created"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.created ?? ""),
			},
			{
				id: (c) => c.ordered ?? "",
				key: "ordered",
				name: SBTranslate("ordered"),
				csvName: SBTranslate("transferenceOrderCSVNames.ordered"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.ordered ?? ""),
			},
			{
				id: (c) => c.expected ?? "",
				key: "expected",
				name: SBTranslate("expected"),
				csvName: SBTranslate("transferenceOrderCSVNames.expected"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.expected ?? ""),
			},
			{
				id: (c) => c.integrated ?? "",
				key: "integrated",
				name: SBTranslate("integrated"),
				csvName: SBTranslate("transferenceOrderCSVNames.integrated"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.integrated ?? ""),
			},
			{
				id: (c) => c.received ?? "",
				key: "received",
				name: SBTranslate("received"),
				csvName: SBTranslate("transferenceOrderCSVNames.received"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.received ?? ""),
			},
			{
				id: (c) => c.closed ?? "",
				key: "closed",
				name: SBTranslate("closed"),
				csvName: SBTranslate("transferenceOrderCSVNames.closed"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.closed ?? ""),
			},
		],
	});

	add({
		id: () => "values",
		name: "values",
		headers: [
			{
				id: (c) => c.quantity,
				key: "quantity",
				name: SBTranslate("quantity"),
				csvName: SBTranslate("transferenceOrderCSVNames.quantity"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.receivedQuantity,
				key: "receivedQuantity",
				name: SBTranslate("receivedQuantity"),
				csvName: SBTranslate("transferenceOrderCSVNames.receivedQuantity"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.supplyBrainRecommendation,
				key: "supplyBrainRecommendation",
				name: SBTranslate("supplyBrainRecommendation"),
				csvName: SBTranslate(
					"transferenceOrderCSVNames.supplyBrainRecommendation",
				),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
		],
	});

	return { headers: build() };
};
